<template>
    <!-- megasus 일 경우 -->
    <v-app v-if="$route.meta.newTab === true"
           :style="'font-family:' + $store.getters.getLangValue('font_family') + '!important'"
           id="preregWrap">


        <router-view>

        </router-view>

    </v-app>
    <v-app v-else
           id="app" :style="'font-family:' + $store.getters.getLangValue('font_family') + '!important'">
        <div id="wrap">
            <div v-if="$store.state.siteOpen">

                <Header></Header>

                <div id="boxContainer"
                     class="allBg">
                    <Mainvisual></Mainvisual>
                </div>
        
                <Footer></Footer>
            </div>
        </div>

        <v-bottom-navigation style="z-index: 1004; position: sticky; bottom: 0; height: 100px; box-shadow: none; margin: 0 auto; background: transparent;"
                             ref="bottomNav"
                             class="bottomNav"
                             width="350px"
                             v-show="!$store.state.isPreRegOpen">
            <!--@click="eventGtag"-->
            <a target="_blank"
               href="https://store.steampowered.com/app/985810/GrandChase/">
                <img :src="`images/section0-btn-after-${$store.state.lang}.png`"
                     style="height: 100px;" />
            </a>
        </v-bottom-navigation>

    </v-app>
</template>

<script>
    import Header from '@/components/header.vue'
    import Mainvisual from '@/components/Mainvisual.vue'
    import Footer from '@/components/Footer.vue'
  
    export default {

        name: 'App',
        components: {
            Header,
            Mainvisual,
            Footer,
        },
        metaInfo() {
            return {
                title: this.metainfoData.title,
                meta: this.metainfoData.meta
            }
        },
        data() {
            return {
                metainfoData: {
                    title: 'GRAND CHASE CLASSIC - Ereb',
                    meta: [
                        { name: 'description', content: 'GRAND CHASE CLASSIC Ereb'},
                        { property: 'og:image', content: 'https://www.koggames.com/game/grandchaseclassic/event/ereb/thumb.png'},
                        { property: 'og:url', content: 'https://www.koggames.com/game/grandchaseclassic/event/ereb' },
                        { property: 'og:description', content: 'GRAND CHASE CLASSIC Ereb' },
                        { property: 'og:type', content: 'game' },
                        { property: 'og:site_name', content: 'GrandChase' },
                        { property: 'twitter:image', content: 'https://www.koggames.com/game/grandchaseclassic/event/ereb/thumb.png'},
                        { property: 'twitter:url', content: 'https://www.koggames.com/game/grandchaseclassic/event/ereb'},
                        { property: 'twitter:site_name', content: 'GrandChase'},
                        { property: 'twitter:type', content: 'game'},
                    ]
                } 
            }
        },
        created() {
            localStorage.setItem('lang', this.$store.state.lang)
        },
        mounted() {
            this.fnPreCheckEventInfo()

            if (!this.$store.state.isPreRegOpen) { 
                window.addEventListener('scroll', () => {
                    const scrollY = window.scrollY;

                    if (scrollY > 800) {
                        document.querySelector('.bottomNav')?.classList.add('show');
                    } else {
                        document.querySelector('.bottomNav')?.classList.remove('show');
                    }
                })
            }
        },
        methods: {
            eventGtag() {
                this.$gtag.event('Game Click', {
                    action_name: '게임바로가기 클릭'
                })
            },
            fnPreCheckEventInfo() {
                let eventOptions = {
                    headers: { 'Content-Type': 'application/json' },
                    url: this.$store.state.evtApiServer + '/event/eventInfo?eventKey=' + process.env.VUE_APP_CONF_EVENT_KEY,
                    method: 'get',
                }
                this.$axios(eventOptions)
                    .then((res) => {
                        if (res.data.EventUID > 0) {
                            var _now = (new Date()).getTime();
                            this.$store.state.evtBase['EventUID'] = res.data.EventUID;
                            this.$store.state.evtBase['EventKey'] = res.data.EventKey;
                            this.$store.state.evtBase['SiteOpenTime'] = new Date(res.data.SiteOpenTime + 'Z');
                            this.$store.state.evtBase['SiteCloseTime'] = new Date(res.data.SiteCloseTime + 'Z');
                            this.$store.state.evtBase['RegStartTime'] = new Date(res.data.RegStartTime + 'Z');
                            this.$store.state.evtBase['RegEndTime'] = new Date(res.data.RegEndTime + 'Z');
                            this.$store.state.evtBase['ClientCountryCode'] = res.data.ClientCountryCode;
                            this.$store.state.evtBase['ClientIP'] = res.data.ClientIP;

                            console.log('SiteOpenTime : ' + this.$store.state.evtBase['SiteOpenTime']);

                            this.$store.state.siteOpen = true

                            if (this.$store.state.evtBase.SiteOpenTime.getTime() > _now || this.$store.state.evtBase.SiteCloseTime.getTime() < _now) {
                                // closed event
                                if (this.$store.state.isLiveServer == 'false') {
                                    alert(this.$store.getters.getLangValue('evt-111'));
                                } 

                                location.replace('https://www.koggames.com/game/grandchaseclassic');
                            }

                            if (this.$store.state.evtBase.RegStartTime.getTime() <= _now && this.$store.state.evtBase.RegEndTime.getTime() >= _now) {
                                // to do 이벤트 폼 생성
                                this.$store.state.isPreRegOpen = true

                            } else {

                                 // location.replace('https://www.koggames.com/game/grandchaseclassic');
                            }

                        } else {
                            if (this.$store.state.isLiveServer == 'false') {
                                alert(this.$store.getters.getLangValue('evt-110'));
                            }

                            this.$store.state.siteOpen = false

                            location.replace('https://www.koggames.com/game/grandchaseclassic');
                        }
                    })
                    .catch((err) => {
                        console.error(`${err} (${err.status})\n\nMessage: ${err.responseText}`);
                        this.$store.state.siteOpen = false

                        location.replace('https://www.koggames.com/game/grandchaseclassic');
                    })
            },
        }
    };
</script>

<style lang="scss">
    @font-face {
        font-family: 'KOTRAHOPE';
        src: url('../public/font/KOTRA HOPE.otf')
    }
    @font-face {
        font-family: 'KOTRALEAP';
        src: url('../public/font/KOTRA LEAP_OTF.otf')
    }
    @font-face {
        font-family: 'VITROCORE OTF';
        src: url('../public/font/VITRO CORE OTF.otf')
    }
    @font-face {
        font-family: 'VITROINSPIRE OTF';
        src: url('../public/font/VITRO INSPIRE OTF.otf')
    }
    @font-face {
        font-family: 'VITROPRIDE OTF';
        src: url('../public/font/VITRO PRIDE OTF.otf')
    }

    @font-face {
        font-family: 'SunBatang';
        font-weight: 300;
        src: url('../public/font/SunBatang-Light.otf')
    }
    @font-face {
        font-family: 'SunBatang';
        font-weight: 500;
        src: url('../public/font/SunBatang-Medium.otf')
    }
    @font-face {
        font-family: 'SunBatang';
        font-weight: 900;
        src: url('../public/font/SunBatang-Bold.otf')
    }
    @font-face {
        font-family: '05HomuraM';
        font-weight: 600;
        src: url('../public/font/05HomuraM-SemiBold-2.otf')
    }

    @font-face {
        font-family: 'LTRemark';
        font-weight: 500;
        src: url('../public/font/LTRemark-Regular.otf')
    }

    @font-face {
        font-family: 'LTRemark';
        font-weight: 700;
        src: url('../public/font/LTRemark-Bold.otf')
    }

    @font-face {
        font-family: 'LTRemark';
        font-weight: 900;
        src: url('../public/font/LTRemark-Black.otf')
    }

    @font-face {
        font-family: 'SBAggro';
        font-weight: 300;
        src: url('../public/font/SB-Aggro-L.ttf')
    }

    @font-face {
        font-family: 'SBAggro';
        font-weight: 500;
        src: url('../public/font/SB-Aggro-M.ttf')
    }

    @font-face {
        font-family: 'SBAggro';
        font-weight: 900;
        src: url('../public/font/SB-Aggro-B.ttf')
    }

    @font-face {
        font-family: 'NotoSansSC';
        font-weight: 700;
        src: url('../public/font/NotoSansSC-Bold.ttf')
    }
    @font-face {
        font-family: 'NotoSansSC';
        font-weight: 500;
        src: url('../public/font/NotoSansSC-Medium.ttf')
    }


    @import './assets/scss/reset.scss';

    .bottomNav {
        display: none;
        opacity: 0;
        &.show {
            opacity: 1;
            display: block;
        }
    }

    #preregWrap {
        > div {
            width: 100%;
            justify-content: center;
            align-items: center;
        }
    }

    .titleStyle {
        font-weight: 800;
        font-size: 40px;
        color: #99a1aa;
        letter-spacing: 10px;
        margin-bottom: -10px;
    }
    .titleStyleSpan {
        font-size: 50px;
        color: #626a7f;
        display: inline-block;
        font-weight: 900;
        position: relative;

        > div {
            width: 100%;
            height: 2px;
            background: #626a7f;
            margin: 4px 0;
        }
    }
    .allBg {
         background: url('../public/images/main-background.png') no-repeat top center;
            background-size: cover;

    }
    .reward-title {
        font-size: 50px;
        font-family: 'KOTRALEAP';
        line-height: 50px;
        color: #494949;

        &.blueText {
            color: #25435c;
        }

        p {
            margin: 0;
        }

        img {
            max-width: 180px !important;
            width: 80%;
        }
    }
    p {
        margin: 0;
    }
    span {
        margin: 0;
    }
    #wrap {
    }
    .v-application ul, .v-application ol {
        padding-left: 0;
    }
    section .inner {
        width: 1400px;
        margin: 0 auto;
    }

    @media all and (max-width:1400px) {
        section .inner {
            width: 100%;
            padding: 0 10px;
        }
    }

    @media all and (max-width: 768px) {
        .allBg {
             background: url('../public/images/main-mobile-bg.png') no-repeat top center;
                             background-size: cover;
        }
        .reward-title {
            font-size: 30px;
            line-height: 30px;
            p {
                margin: 0;
            }
            img {
                max-width: 100px !important;
                width: 80%;
            }
        }
    }

    @media all and (max-width: 768px) {
        #preregWrap {
        }
        #wrap {
        }

        .reward-title {
            font-size: 20px;
            line-height: 30px;
            width: 100%;
            margin: 10px 10px;

            p {
                margin: 0;
                text-align: center;
            }

            img {
                max-width: 100px !important;
                width: 80%;
            }
        }

        .titleStyleSpan {
            font-size: 36px;
            letter-spacing: 0;
            margin-top: 5px;
        }
    }
</style>